import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ColliTimer, ColliTimerListResponse, ColliTimerQueryParams, CreateColliTimer, UpdateColliTimer } from '@frontend/colli/types';

export class ColliTimerClient extends APIClient {
    public static readonly endpoint = '/colli-api/v1';

    public static async fetchTimers(queryParams?: ApiQueryParams<ColliTimerQueryParams>): Promise<ColliTimerListResponse> {
        return await this.apiPaginated<ColliTimerListResponse, ColliTimerQueryParams>(`${this.endpoint}/timers`, queryParams);
    }

    public static async fetchStartedTimers(queryParams?: ApiQueryParams<ColliTimerQueryParams>): Promise<ColliTimerListResponse> {
        return await this.apiPaginated<ColliTimerListResponse, ColliTimerQueryParams>(`${this.endpoint}/started-timers`, queryParams);
    }

    public static async fetchAccountColliTimers(
        accountId: string,
        transactionId: string,
        colliId: string,
        queryParams?: ApiQueryParams<ColliTimerQueryParams>
    ): Promise<ColliTimerListResponse> {
        return await this.apiPaginated<ColliTimerListResponse, ColliTimerQueryParams>(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/timers`,
            queryParams
        );
    }

    public static async fetchAccountColliTimer(accountId: string, transactionId: string, colliId: string, timerId: string): Promise<ColliTimer> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/timers/${timerId}`);
        return await this.handleResponse<ColliTimer>(response);
    }

    public static async postAccountColliTimer(accountId: string, transactionId: string, colliId: string, body: CreateColliTimer): Promise<ColliTimer> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/timers`, body);
        return await this.handleResponse<ColliTimer>(response);
    }

    public static async patchAccountColliTimer(
        accountId: string,
        transactionId: string,
        colliId: string,
        timerId: string,
        body: UpdateColliTimer
    ): Promise<ColliTimer> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/timers/${timerId}`, body);
        return await this.handleResponse<ColliTimer>(response);
    }

    public static async deleteAccountColliTimer(accountId: string, transactionId: string, colliId: string, timerId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/timers/${timerId}`);
        await this.handleVoidResponse(response);
    }
}
